import {AxiosResponse} from "axios";

export const checkDocument = () => {
    return typeof window === "undefined" || typeof document === "undefined"
}

//Проверка на мобильное устройство
export const isMobile = (maxSize = 768) => {
    if(checkDocument()) return;

    return window.innerWidth <= maxSize
};

export const scrollTop = () => {
    if(checkDocument()) return;

    window.scrollTo({top: 0, behavior: 'smooth'})
}

//Скачивание файла из response
export const downloadResponseFile = (response: AxiosResponse) => {
    if(checkDocument()) return;

    // Попытка получить имя файла из заголовков ответа
    const contentDisposition = response.headers['content-disposition'];
    // Имя файла по умолчанию
    let fileName = 'invoice_stat_resume.xlsx';

    if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch.length > 1) {
            fileName = decodeURIComponent(fileNameMatch[1]);
        }
    }

    const blob = new Blob([response.data], {type: response.data.type});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export const setCookie = (name: any, value: any, timeInMin: any) => {
    if(checkDocument()) return;

    let expires = "";
    if (timeInMin) {
        const date = new Date();
        date.setTime(date.getTime() + timeInMin * 60 * 1000); // 24 hours
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const getCookie = (name: String) => {
    if(checkDocument()) return;

    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export const copyText = (text: string) => {
    if(checkDocument()) return;

    var textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    textField.focus();
    document.execCommand('copy');
    textField.remove();
}

export const numberCommaFormat = (number: any) => {
    if (isNaN(number)) return '0';

    return number
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        .replace(/-,/, '-');
}
